/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderOtherChargeRec.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/order-other-charge-rec";

export class AutogenModelOrderOtherChargeRec<RowType extends ModelRow> extends Endpoint<RowType, RowOrderOtherChargeRecFields> {
    constructor(ctor: RowConstructor) {
        super(endpointPath, ctor);
    }
}

export class AutogenRowOrderOtherChargeRec extends ModelRow<RowOrderOtherChargeRecFields> {
    constructor(values?: Partial<RowOrderOtherChargeRecFields>) {
        super(endpointPath, true, values);
    }
}

export interface RowOrderOtherChargeRecFields {
    amount: number;
    amount_c: string;
    amount_d: Date;
    amount_n: number;
    amount_r: number;
    bill_type: string;
    calc_method: string;
    charge_id: string;
    company_id: string;
    customer_id: string;
    descr: string;
    driver_id: string;
    est_fuel_surcharge: string;
    id: string;
    invoice_id: string;
    is_taxable: string;
    order_id: string;
    rate: number;
    sequence: number;
    stop_loc_name: string;
    stop_no: string;
    units: number;
}

